<div [ngClass]="{ 'content-box py-1': inContentBox }" *ngIf="currencyConfig$ | async as config">
  <shrd-uic-listbox class="w-100" [allowDeselect]="false" (optionsChanged)="onCurrencyChange($event)">
    <shrd-uic-flyout-option
      class="d-block"
      className="my-0"
      *ngFor="let option of config.currencies"
      [value]="option"
      [selected]="option === config.activeCurrency"
    >
      <span class="d-block text-uppercase">
        {{ option.code }}
        <ng-container *ngIf="option.rate && option.base">
          &nbsp;({{ option.code }}/{{ option.base }}&nbsp;=&nbsp;{{ option.rate }})&#x200E;
        </ng-container>
      </span>
    </shrd-uic-flyout-option>
  </shrd-uic-listbox>
</div>
